"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurePathBuilder = exports.RefBuilder = exports.PathBuilder = exports.setFirestoreAuth = exports.RefBuilderLite = void 0;
var lite_1 = require("./lite");
Object.defineProperty(exports, "RefBuilderLite", { enumerable: true, get: function () { return lite_1.RefBuilder; } });
Object.defineProperty(exports, "setFirestoreAuth", { enumerable: true, get: function () { return lite_1.setFirestoreAuth; } });
var refs_1 = require("./refs");
Object.defineProperty(exports, "PathBuilder", { enumerable: true, get: function () { return refs_1.PathBuilder; } });
Object.defineProperty(exports, "RefBuilder", { enumerable: true, get: function () { return refs_1.RefBuilder; } });
var secure_1 = require("./secure");
Object.defineProperty(exports, "SecurePathBuilder", { enumerable: true, get: function () { return secure_1.SecurePathBuilder; } });
//# sourceMappingURL=index.js.map